module.exports = __webpack_public_path__ + "img/perforaciones_9-16_540.9938bb4a.webp";